<!--
트래킹검수 > 헤더
------------------------------------
-->
<template>
    <div>
        <!-- 안건 72 (2026-05-12): 옛 menuHtml 인라인 펼침 UX 폐기 → 좌측 ref020-sidebar 토글 -->
        <div class="search-bar uk-flex uk-flex-between">
            <!-- 메뉴 토글 — window event 로 ref020-sidebar 슬라이드인/아웃 -->
            <a class="menu" @click="toggleSidebar" title="사이드바 토글">
                <i class="material-icons">menu</i>
            </a>

            <!-- 스캔번호 -->
            <div class="scan-no" @click="$parent.showScan" title="Retry scan">
                <i class="material-icons">
                    aspect_ratio
                </i>
                입고스캔
                <span class="none uk-margin-small-left" v-show="! scannedNo">NONE</span>
                <span class="highlight uk-margin-small-left" v-show="scannedNo">
                {{ scannedNo }}
            </span>
            </div>

            <div class="uk-width-expand"></div>

            <!-- 스캔내역 리스트 -->
            <div class="scanned-list" @click="$parent.showList" title="Show scanned list">
                <i class="material-icons">
                    list
                </i>
                SCANNED
                <span class="highlight">{{ shipInList.length }}</span>
                BOX
            </div>
        </div>
    </div>
</template>

<script>
// REF-020 hot-fix #20 안건 72 (2026-05-12): menu-able mixin 폐기.
//   기존 mixin: 옛 메뉴 HTML 을 ajax 로 가져와 v-html 로 inline 펼침 (menuOpen / menuHtml / changeMenuStatus / loadMenu).
//   변경 후: 메뉴버튼 클릭 시 ref020-sidebar 의 toggle window event dispatch.
//            mixin 자체 미사용 (다른 사용처는 일괄 폐기 — nodata-scan, tracking-check layout-header).
export default {
    props: {
        /**
         * 지역id
         */
        regionId: {
            type: Number,
            default: null,
        },

        /**
         * 현재 스캔된 정보
         */
        scan: {
            type: Object,
            default: null,
        },

        /**
         * 스캔내역
         */
        shipInList: {
            type: Array,
            default: [],
        },


    },
    data: function () {
        return {};
    },
    computed: {
        scannedNo() {
            if (!this.scan) {
                return null;
            }
            return this.scan.scanned_no;
        }
    },
    methods: {
        // 안건 72 (2026-05-12): 메뉴버튼 클릭 시 ref020-sidebar 토글 (sidebar.vue 가 listener 등록).
        toggleSidebar() {
            window.dispatchEvent(new CustomEvent('ref020-sidebar-toggle'));
        },
    },
}
</script>

<style lang="scss" scoped>
.search-bar {
    border: 0;
    //padding: 10px;
    background-color: #922209 !important;


    font-size: 1.5rem;
    color: #fff;

    // 자식 1뎁스메뉴 패딩처리
    & > div {
        padding: 0.5rem;
    }

    // 메뉴 펼치기
    a.menu {
        display: flex;
        align-items: center;
        text-decoration: none;

        padding: 0 0.5rem;
        color: #fff;

        .material-icons {
            font-size: 2rem;
        }


        &.open {
            color: #1F2B3D;
            background-color: #fff;
        }


    }

    .material-icons {
        vertical-align: middle;
        font-size: 30px;
    }

    .none {
        font-size: 1.5rem;
        color: #fff366;
    }

    .highlight {
        font-size: 3rem;
        color: #000;
        background-color: #ffffcc;
        padding: 0 10px;
        display: inline-block;
        vertical-align: bottom;
        //color: rgb(238, 241, 245);

        //color: #0f7ae5;
    }


    .scan-no {
        cursor: pointer;
    }

    .scanned-list {
        cursor: pointer;
    }

}
</style>